import { toast } from "react-toastify";
import { MediaAPI } from "../constants/apiRoutes";
import { mediaActions } from "../reducers/media";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const createNewImage = (files) => {
  return async (dispatch) => {
    dispatch(mediaActions.actionStart());

    try {
      const formData = new FormData();

      const arr = Array.isArray(files) ? files : [files];
      arr.forEach((file) => {
        formData.append("files", file); // <-- ključno (swagger: files)
      });

      const res = await apiService.postMultipart(MediaAPI.create(), formData);

      dispatch(mediaActions.actionSuccess("create"));

      dispatch(fetchMediaList());

      toast.success("Slika je uspešno dodata.", { theme: "colored" });

      // VRATI backend response da modal može da ubaci u state
      return res.data;
    } catch (err) {
      dispatch(mediaActions.clearError());
      handleError(err);
      throw err; // da caller može da uhvati ako treba
    }
  };
};

export const fetchMediaList = () => {
  return (dispatch) => {
    return apiService
      .get(MediaAPI.get())
      .then((response) => {
        dispatch(mediaActions.fetchMediaList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteMedia = (id) => {
  return (dispatch) => {
    return apiService
      .delete(MediaAPI.delete(id))
      .then((response) => {
        toast.success("Uspešno ste obrisali sliku", {
          theme: "colored",
        });
        dispatch(fetchMediaList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
